import {getLatLngFromPointGeomCoordinates} from "@helpers/geoJson/getLatLngFromPointGeomCoordinates";

const DEFAULT_LAT_LNG: [lat: number, lng: number] = [49.83789941810383, 24.03688430786133]

export const getInitialMapCenterByPointsSingleVoyage = (points: {
	geom: {
		type: "Point",
		coordinates: [lng: number, lat: number]
	}
}[]): [lat: number, lng: number] => {
	if (!points?.length) {
		return DEFAULT_LAT_LNG
	}
	
	const point = points[0];
	if (!point?.geom?.coordinates?.length) {
		return DEFAULT_LAT_LNG
	}
	
	const {lat, lng} = getLatLngFromPointGeomCoordinates(point.geom)
	return [
		lat, lng
	]
}
